var map = {
	"./app-a.png": "ThcU",
	"./app.png": "QkEL",
	"./iot-a.png": "+JSb",
	"./iot.png": "vqhG",
	"./menu.png": "8wfO",
	"./order-a.png": "7Mlq",
	"./order.png": "orgn",
	"./product-a.png": "RYWQ",
	"./product-tool-a.png": "IGQC",
	"./product-tool.png": "dC9W",
	"./product.png": "JGvK",
	"./settings-a.png": "FwhG",
	"./settings.png": "/ECs",
	"./statistics-a.png": "ESpF",
	"./statistics.png": "XO2L"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LDtV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu ^\.\/.*\.png$
// module id = LDtV
// module chunks = 1